<div id="why" data-scroll>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="diagram justify-content-center d-flex align-items-center mx-auto">
                        <div class="center-circle text-center justify-content-center d-flex align-items-center" (click)="scrollTo('.about')">
                            <h5>Quality over 20 Years</h5>
                        </div>
                        <div class="circle text-center c1 justify-content-center d-flex align-items-center" data-toggle="modal" data-target="#visionModal">
                            <h6>Vision</h6>
                        </div>
                        <div class="circle text-center justify-content-center d-flex align-items-center c2" data-toggle="modal" data-target="#missionModal">
                            <h6>Mission</h6>
                        </div>
                        <div class="circle text-center justify-content-center d-flex align-items-center c3" data-toggle="modal" data-target="#motiveModal">
                            <h6>Our Main Motive</h6>
                        </div>
                        <div class="circle text-center justify-content-center d-flex align-items-center c4" data-toggle="modal" data-target="#theoryModal">
                            <h6>Our Theory</h6>
                        </div>
                        <div class="circle text-center justify-content-center d-flex align-items-center c5" data-toggle="modal" data-target="#preModal">
                            <h6>Pre-kindergarten</h6>
                        </div>
                        <div class="circle text-center justify-content-center d-flex align-items-center c6" data-toggle="modal" data-target="#computerModal">
                            <h6>Computer Lab</h6>
                        </div>
                        <div class="circle text-center justify-content-center d-flex align-items-center c7"  data-toggle="modal" data-target="#transportModal">
                            <h6>Transport</h6>
                        </div>
                        <div class="circle text-center justify-content-center d-flex align-items-center c8" data-toggle="modal" data-target="#campusModal">
                            <h6>Campus</h6>
                        </div>
                </div>
                
            </div>
            <div class="col-12 col-xl-6 my-auto">
            
                <div class="detail ">
                    <h4>WHY MPPS</h4>
                    <h2 class="font-weight-bold">PREPARING YOU<br>
                        <strong>FOR LIFE</strong> 
                    </h2>
                    
                   <img [src]="imgUrl" alt="" class="img-fluid">
                    
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade " id="aboutModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Quality over 22 Years</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
              <h2 class="card-title px-lg-2">Welcome @Springdale Public School</h2>
            <p class="text-justify px-lg-2">Springdale Public School is a modern and progressive institution; right from its inception in 1990 it’s a vision translated into reality with a mission to create leaders, winners and achievers in a global world.</p>
            <p class="text-justify px-lg-2">It embodies the very philosophy of our reverend founder. Bhatnagar to shape up and mould students in such a manner that they are dedicated to the cause of the overall progress of the society, blending traditions with progressive change.</p>
            <p class="text-justify px-lg-2">The school firmly believes that value based learning has far greater relevance in a dynamic and ever changing environment. At the senior secondary level the school offers three streams – Science, Commerce and Humanities ensuring results par excellence…</p>
          </div>
      </div>
    </div>
  </div>

  <div class="modal fade " id="visionModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Vision</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
              <!-- <h2 class="card-title px-lg-2">Our Approach</h2> -->
              <p class="text-justify">To be a temple of learning where the devotees are nurtured to worship knowledge and harness it for the good of mankind.</p> 
          </div>
      </div>
    </div>
  </div>


  <div class="modal fade " id="missionModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Mission</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
             <p class="text-justify">To provide quality education to the children with minimum financial burden on the parents.
                to ensure  physical mental and moral growth of the students and create in them a zest for learning.                
            </p>
            <p class="text-justify">To judiciously arouse their aesthetic sense and inculcate habits of personal as well as social hygiene for overall well being.            
            </p>
            <p class="text-justify">To engage the students in cooperative endeavors so as to develop in them team spirit and a service mentality.              
            </p>
            <p class="text-justify">To channelize youthful energies towards creativity & self actualization.            
            </p>
          </div>
      </div>
    </div>
  </div>


  <div class="modal fade " id="motiveModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Our Main Motive</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
             <p class="text-justify">Provide quality education to children with minimum financial burden on the Parent.
                  We provide students with an immersive, collaborative, and inspiring environment where they can develop a broadly informed, highly disciplined intellect that will help them be successful in whatever work they finally choose.</p>
          </div>
      </div>
    </div>
  </div>


  <div class="modal fade " id="theoryModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Our Theory</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
            <p class="text-justify">We believe that children are active participants in their own learning. That’s why we encourage them to ask questions and explore the world around them. </p>
            <p class="text-justify">We also focus on essential life skills such as communication and self-regulation.
                 Plus, children are routinely encouraged to take on challenges, develop their own learning goals, see situations from different perspectives etc.</p>

          </div>
      </div>
    </div>
  </div>


  <div class="modal fade " id="preModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Pre-kindergarten</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
             
            <p class="text-justify"> Our Pre-Kindergarten classroom is designed to help your child make significant developmental gains, communicate more successfully, and work well both independently and in group situations.
                 Building on Preschool learning, Pre-K learning focuses on problem-solving, responsive listening and language usage, as well as social and collaborative skills, with specific lessons in Reading, Writing, Math etc.</p>
                 <p class="text-justify"> Each child is different, therefore special. Keeping this in focus, we endeavor to develop all the attributes & skills of the children in a holistic manner so that they adapt themselves to the constantly changing environment.
                      To inculcate creativity & critical thinking in order to encourage logical decision making & innovation, the school is all prepared to implement NEW EDUCATION POLICY.
                </p>
          </div>
      </div>
    </div>
  </div>

  <div class="modal fade " id="computerModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Computer Lab</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
            <p class="text-justify">A lab that teaches not just computer science as a subject, but also, the integration of computer skills for learning of other subjects.</p>
          </div>
      </div>
    </div>
  </div>

  <div class="modal fade " id="transportModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Transport</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
            <p class="text-justify">The transportation of students is quick and convenient due to a fleet of comfortable and deluxe buses on a contract basis.</p>
          </div>
      </div>
    </div>
  </div>

  <div class="modal fade " id="campusModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Campus</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
             <p class="text-justify">The campus has been modeled to facilitate the finest educational services and enhance all-round development of children.</p>
          </div>
      </div>
    </div>
  </div>


